module.exports = __webpack_public_path__ + "static/img/rys.127389e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rys.jpg
// module id = i878
// module chunks = 1